import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'
import { editorConfiguration, editorConfigurationWithoutImage, minimalConfig } from 'util/ckeditor-config'

const CkeditorComponentV2 = ({
  data = '',
  configuration = 'full',
  onChange = () => {},
  onBlur = () => {},
  onFocus = () => {},
  disabled = false,
  otherConfigs = {},
}) => {
  function getConfig(config = '') {
    let defaultConfig = editorConfiguration

    switch (config) {
      case 'full':
        defaultConfig = editorConfiguration
        break
      case 'full-without-image':
        defaultConfig = editorConfigurationWithoutImage
        break
      case 'minimal':
        defaultConfig = minimalConfig
        break
      default:
        defaultConfig = editorConfiguration
        break
    }

    return {
      ...defaultConfig,
      isReadOnly: disabled,
      disabled,
      ...otherConfigs,
    }
  }

  return (
    <CKEditor
      editor={Editor}
      data={data}

      config={getConfig(configuration)}
      onChange={(_, editor) => {
        const data = editor.getData()
        onChange(data)
      }}
      onBlur={(_, editor) => {
        const data = editor.getData()
        onBlur(data)
      }}
      onFocus={(_, editor) => {
        const data = editor.getData()
        onFocus(data)
      }}
    />
  )
}

export default CkeditorComponentV2
